import { CheckCircleOutlined } from '@ant-design/icons'
import { Button, Col, InputNumber, Modal, Row, Space, Tag } from 'antd'
import React from 'react'

const ModalGestionTauxDeCommission = ({ tcModalOpen, setTCModalOpen, saveTauxCommissions, tauxCommissions, setTauxCommissions, courtier }) => {
    const handleTauxChange = (key, value) => {
        const newTaux = tauxCommissions.map(item =>
            item.codeCategorie === key ? { ...item, taux: value } : item
        );
        setTauxCommissions(newTaux);
    };
    return (
        <Modal
            title={
                <div style={{
                    fontSize: '20px',
                    fontWeight: 700,
                    color: '#242166'
                }}>
                    Gestion des taux de commission
                </div>
            }
            open={tcModalOpen}
            onCancel={() => setTCModalOpen(false)}
            width={700}
            footer={[
                <Button
                    key="cancel"
                    size="large"
                    onClick={() => setTCModalOpen(false)}
                    style={{ borderRadius: '8px' }}
                >
                    Annuler
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    size="large"
                    onClick={saveTauxCommissions}
                    style={{
                        background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: 600
                    }}
                >
                    Enregistrer les taux
                </Button>,
            ]}
        >
            <p style={{
                color: '#8c8c8c',
                marginBottom: '24px',
                fontSize: '14px'
            }}>
                Définissez les taux de commission pour chaque catégorie d'assurance pour{' '}
                <strong style={{ color: '#242166' }}>{courtier?.nom}</strong>
            </p>

            <div style={{
                background: '#fafafa',
                padding: '16px',
                borderRadius: '8px',
                marginBottom: '16px'
            }}>
                <Row gutter={[16, 16]}>
                    <Col span={14}>
                        <strong style={{ color: '#262626' }}>Catégorie</strong>
                    </Col>
                    <Col span={10}>
                        <strong style={{ color: '#262626' }}>Taux (%)</strong>
                    </Col>
                </Row>
            </div>

            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                {tauxCommissions?.map((item) => (
                    <Row
                        key={item?.codeCategorie}
                        gutter={[16, 16]}
                        align="middle"
                        style={{
                            padding: '12px',
                            background: 'white',
                            border: '1px solid #f0f0f0',
                            borderRadius: '8px'
                        }}
                    >
                        <Col span={14}>
                            <div>
                                <div style={{
                                    fontWeight: 600,
                                    color: '#262626',
                                    marginBottom: '4px'
                                }}>
                                    {item?.categorie}
                                </div>
                                <Tag
                                    color="#242166"
                                    style={{
                                        fontSize: '11px',
                                        borderRadius: '4px'
                                    }}
                                >
                                    {item?.codeCategorie}
                                </Tag>
                            </div>
                        </Col>
                        <Col span={10}>
                            <InputNumber
                                value={item?.taux}
                                onChange={(value) => handleTauxChange(item?.codeCategorie, value)}
                                min={0}
                                max={100}
                                step={0.1}
                                precision={2}
                                suffix="%"
                                size="large"
                                style={{
                                    width: '100%',
                                    borderRadius: '8px',
                                    borderColor: '#242166'
                                }}
                            />
                        </Col>
                    </Row>
                ))}
            </Space>

            <div style={{
                marginTop: '24px',
                padding: '16px',
                background: '#e6f7ff',
                borderRadius: '8px',
                border: '1px solid #91d5ff'
            }}>
                <Space>
                    <CheckCircleOutlined style={{ color: '#1890ff' }} />
                    <span style={{ color: '#262626', fontSize: '13px' }}>
                        Les modifications seront appliquées immédiatement après enregistrement
                    </span>
                </Space>
            </div>
        </Modal>
    )
}

export default ModalGestionTauxDeCommission